import { Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { useRemoveAppDeployment } from '@/queries/deploymentQueries'
import { DeploymentOverviewApp } from '@/types/deploymentGroup'
import { GroupConfirmModal } from './GroupConfirmModal'
import { summarizeApp } from './deploymentTreeHelpers'
import { useRunDeploymentAction } from './useRunDeploymentAction'

type AppDeploymentDeleteConfirmProps = {
  opened: boolean
  app: DeploymentOverviewApp
  onClose: () => void
}

export const AppDeploymentDeleteConfirm = ({
  opened,
  app,
  onClose
}: AppDeploymentDeleteConfirmProps) => {
  const { mutateAsync: removeAppDeployment, isPending } =
    useRemoveAppDeployment()
  const run = useRunDeploymentAction(onClose)

  const summary = summarizeApp(app)

  const handleConfirm = () =>
    void run(() => removeAppDeployment(app.application_id), {
      inProgress: 'deployments.app.delete.inProgress',
      error: 'deployments.app.delete.error'
    })

  return (
    <GroupConfirmModal
      opened={opened}
      title={<FormattedMessage id="deployments.app.delete.title" />}
      confirmLabel={<FormattedMessage id="deployments.app.delete.title" />}
      confirmColor="red"
      isPending={isPending}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <Text size="sm">
        <FormattedMessage
          id="deployments.app.delete.confirmation"
          values={{
            application: app.application_name,
            groups: summary.groups,
            cameras: summary.cameras,
            folders: summary.folders
          }}
        />
      </Text>
    </GroupConfirmModal>
  )
}
